// extracted by mini-css-extract-plugin
export default {"titleLink":"NetworkBatchComparison_titleLink__AnuNL","playableLink":"NetworkBatchComparison_playableLink__ltZ3U"};